import React from 'react';
import { QuestRoute } from '../api/QuestRoutes';
import { generateId, statusColors, translate } from '../utility/functions';
import Dot from '../Dot';
import Table from '../table/Table';
import LinkTo from '../forms/LinkTo';
import { IsAuthorized, userRoles } from '../RoleProtected';
import Row from '../layout/Row';
import Page from '../layout/Page';

const MediaLookUp = ({ ...props }) => {
    const isAuthorized = IsAuthorized(userRoles.viewCustomers);

    // console.log(props)

    const tableConfig = {
        getData: QuestRoute.expressPass.media,
        headers: [
            {
                label: 'Media ID',
                propKey: 'mediaId',
            }, {
                label: 'Type',
                propKey: 'type',
                options: true,
            }, {
                label: 'Status',
                propKey: 'status',
                options: true,
                sortBy: true,
            }, {
                label: 'Account',
                propKey: 'accountName',
            },
        ],
        quickSort: [
            {
                label: 'Active Media',
                propKey: 'status',
                query: 'Active',
                color: '#21D59B'
            }, {
                label: 'RFIDs',
                propKey: 'type',
                query: 'RFID',
                color: '#9fc75e'
            }, {
                label: 'License Plates',
                propKey: 'type',
                query: 'LicensePlate',
                color: '#b493e0'
            }
        ],
        renderFormat: (e) => (
            <tr key={generateId()}>
                <td>{e.mediaId}</td>
                <td>{translate(e.type)}</td>
                <td>
                    <Row>
                        <Dot color={statusColors[e.status]} />
                        <span>
                            {e.status}
                        </span>
                    </Row>
                </td>
                <td>
                    {isAuthorized ?
                        <LinkTo toAccount={e}>{e.accountName}</LinkTo> : <div>{e.accountName}</div>}
                </td>
            </tr>
        )
    }

    if (props.justTable) return (<Table config={tableConfig} />);

    return (
        <Page title='Media Lookup' icon='magnifyingGlass'>
            <Table config={tableConfig} />
        </Page>
    )
}

export default MediaLookUp;